import algoliaInsights from 'search-insights';

const ALGOLIA_CLIENT_ID = process.env.REACT_APP_ALGOLIA_APP_ID;
const ALGOLIA_API_KEY = process.env.REACT_APP_ALGOLIA_SEARCH_API_KEY;
const ALGOLIA_INDEX = process.env.REACT_APP_ALGOLIA_LISTINGS_INDEX;

algoliaInsights('init', {
  appId: ALGOLIA_CLIENT_ID,
  apiKey: ALGOLIA_API_KEY,
});

export const sendQuerySubmittedEvent = ({ currentUserId = 'anonymous-user', keyword }) =>
  algoliaInsights('clickedObjectIDs', {
    userToken: currentUserId,
    eventName: 'Search Keyword Used',
    // queryID: keyword,
    objectIDs: ['6789fd50-9f0d-406d-9fe4-b70380334189'],
    index: ALGOLIA_INDEX,
    extraParams: {
      searchKeyword: keyword,
    },
  });

export const sendFacetClickedEvent = ({ currentUserId = 'anonymous-user', attribute, value }) =>
  algoliaInsights('clickedObjectIDs', {
    userToken: currentUserId,
    eventName: 'Filter Clicked',
    index: ALGOLIA_INDEX,
    filters: [`${attribute}:${value}`],
  });

export const requestQuoteClickedEvent = ({
  currentUserId = 'anonymous-user',
  listingId,
  queryId,
  extraParams = {},
}) =>
  algoliaInsights(queryId ? 'convertedObjectIDsAfterSearch' : 'convertedObjectIDs', {
    userToken: currentUserId,
    authenticatedUserToken: currentUserId,
    eventName: 'Listing Quote Requested',
    index: ALGOLIA_INDEX,
    objectIDs: [listingId],
    ...(queryId ? { inferQueryID: queryId } : {}),
    extraParams,
  });

export const quoteAcceptedClickedEvent = ({
  currentUserId = 'anonymous-user',
  listingId,
  queryId,
  extraParams = {},
}) =>
  algoliaInsights(queryId ? 'convertedObjectIDsAfterSearch' : 'convertedObjectIDs', {
    userToken: currentUserId,
    authenticatedUserToken: currentUserId,
    eventName: 'Listing Quote Accepted',
    index: ALGOLIA_INDEX,
    objectIDs: [listingId],
    ...(queryId ? { inferQueryID: queryId } : {}),
    extraParams,
  });
